import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { Route, useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import {
	MdOutlineAdminPanelSettings,
	MdStorefront,
	MdPersonOutline,
	MdOutlineHelpOutline,
	MdOutlineLogout,
	MdLogin,
	MdPersonAdd,
	MdStar,
	MdOutlineMonetizationOn,
	MdOutlineApi,
	MdOutlineSecurity,
	MdOutlinePrivacyTip,
	MdOutlinePolicy,
	MdOutlineArrowBack,
} from "react-icons/md";

import { Nav } from "react-bootstrap";
import {
	Content,
	ContentPage,
	Kitten,
	Notifications,
	PrivacyPolicies,
	UserInfo,
	Wrraper,
} from "./styled";
import { Menu } from "../../components/menu/menu";
import { ButtonContact } from "../../components/button-contact";

import { UnitiesList } from "./unity/unity-list/unity-list";
import { DisciplineList } from "./discipline/discipline-list/discipline-list";

import { Home } from "./home";
import { DisciplineDetails } from "./discipline/discipline-details";
import { UnityDetails } from "./unity/unity-details";
import { MediaList } from "./media/media-list";
import { Favorites } from "./favorites/favorites-list";
import { Materials } from "./my-links";
import { MediaDetails } from "./media/media-details";
import { UserAccount } from "./user/account";
import { SupportContact } from "./support-contact";

import UsuarioContext from "../../../context/userContext/context";
import { CoursesList } from "./course/courses-list";
import { CourseDetails } from "./course/course-details";
import { Privacy } from "./policies/privacy";
import { ToS } from "./policies/tos";
import {
	getPrivacyPolitics,
	getServiceTerms,
} from "../../services/manager/admin/settings.service";
import { NotificationsPanel } from "./components/notifications-panel";

const Base = (): JSX.Element => {
	const { t: translation } = useTranslation();
	const { user } = useContext(UsuarioContext);
	const history = useHistory();

	const [show, setShow] = useState(true);
	const [showUserInfo, setShowUserInfo] = useState(false);
	const [showPrivacy, setShowPrivacy] = useState(false);
	const showManagerButton = useMemo(
		() => user.is_superuser || user.profile_status === "Parceiro",
		[user]
	);

	/** Verifica se o menu está aberto e fecha todos os outros */
	useEffect(() => {
		if(showUserInfo){
			setShowNotifications(false);
		}
	}, [showUserInfo])

	/** Notificações - mostrar/esconder painel   */
	const [showNotifications, setShowNotifications] = useState(false);

	/** Verifica se o menu está aberto e fecha todos os outros */
	useEffect(() => {
		if(showNotifications){
			setShowUserInfo(false);
		}
	},[showNotifications])

	/** Documentos de privacidade, tos */
	const [hasPrivacyDocs, setHasPrivacyDocs] = useState(false);
	const [availableDocs, setAvailableDocs] = useState<string[]>([]);

	/** Request para verificar quais documentos de privacidade estão disponíveis ao usuário
	 *
	 * O resultado indica se o item de menu "Privacidade" deve ser exibido ou não
	 */
	useEffect(() => {
		let foundDocs: string[] = [];

		const privacyPromise = getPrivacyPolitics().then((data) => {
			if (data.is_public && data.body.length > 0) {
				setHasPrivacyDocs(true);
				foundDocs.push("privacy");
			}
		});

		const tosPromise = getServiceTerms().then((data) => {
			if (data.is_public && data.body.length > 0) {
				setHasPrivacyDocs(true);
				foundDocs.push("tos");
			}
		});

		Promise.all([privacyPromise, tosPromise]).then(() => {
			setAvailableDocs(foundDocs);
		});
	}, []);

	const handleLogout = () => {
		history.push("/login");
	};
	const handleRedirectToDocs = () => {
		window.open(`https://api-dstore.deduca.com.br/redoc`);
	};

	const handleCloseMenus = () => {
		setShowUserInfo(false);
		setShowPrivacy(false);
		setShowNotifications(false);
	};

	return (
		<Fragment>
			<Wrraper>
				<Kitten
					show={show}
					showUserInfo={showUserInfo}
					onClick={() => {
						if (showUserInfo) {
							handleCloseMenus();
							setShow(false);
						} else if (!showUserInfo && show) {
							setShow(false);
						} else {
							setShow(true);
						}
					}}
				>
					{show || showUserInfo ? (
						<FaChevronLeft />
					) : (
						<FaChevronRight />
					)}
				</Kitten>

				{/* Menu principal */}
				<Menu
					show={show}
					setShowUserInfo={setShowUserInfo}
					showUserInfo={showUserInfo}
					closeSubmenus={handleCloseMenus}
					showNotifications={showNotifications}
					setShowNotifications={setShowNotifications}
				/>

				{/* Submenu do Usuário, contém informações de conta, planos, ajuda, privacidade, admin, docs */}
				<UserInfo
					show={show}
					showUserInfo={showUserInfo}
					className={"d-flex flex-column"}
				>
					{showUserInfo && (
						<>
							{user.token ? (
								<>
									<Nav
										className="flex-column p-1"
										onClick={() => {
											window.open(
												"https://aquisicao.dstoreconteudos.com.br/",
												"_blank"
											);
											return null;
										}}
									>
										<Nav.Item className="d-flex align-items-center hoverMenu">
											<span className="d-flex mx-3 menu-icon">
												<MdStorefront />
											</span>{" "}
											{translation(
												"components.menu.accessStore"
											)}
										</Nav.Item>
									</Nav>
									<Nav
										className="flex-column p-1"
										onClick={() => {
											history.push("/user-account");
											handleCloseMenus();
										}}
									>
										<Nav.Item className="d-flex align-items-center hoverMenu">
											<span className="d-flex mx-3 menu-icon">
												<MdPersonOutline />
											</span>{" "}
											{translation(
												"components.menu.account"
											)}
										</Nav.Item>
									</Nav>
									{(user.is_superuser ||
										user.profile_status === "Parceiro" ||
										user.profile_status ===
											"Assinante") && (
										<Nav
											className="flex-column p-1"
											onClick={() => {
												history.push("/plans");
												handleCloseMenus();
											}}
										>
											<Nav.Item className="d-flex align-items-center hoverMenu">
												<span className="d-flex mx-3 menu-icon">
													<MdOutlineMonetizationOn />
												</span>{" "}
												{translation(
													"components.menu.plans"
												)}
											</Nav.Item>
										</Nav>
									)}
									<Nav
										className="flex-column p-1"
										onClick={() => {
											history.push(
												"/contact?subject=Duvídas"
											);
											handleCloseMenus();
										}}
									>
										<Nav.Item className="d-flex align-items-center hoverMenu">
											<span className="d-flex mx-3 menu-icon">
												<MdOutlineHelpOutline />
											</span>{" "}
											{translation(
												"components.menu.help"
											)}
										</Nav.Item>
									</Nav>
									{/* ----- */}
									{/* Botão de termos de uso e privacidade
										Abre o submenu de politicas */}
									{/* ----- */}
									{hasPrivacyDocs && (
										<Nav
											className="flex-column p-1"
											onClick={() => {
												setShowPrivacy(true);
											}}
										>
											<Nav.Item className="d-flex align-items-center hoverMenu ">
												<span className="d-flex mx-3 menu-icon">
													<MdOutlineSecurity />
												</span>
												{translation(
													"components.menu.privacy"
												)}
											</Nav.Item>
										</Nav>
									)}

									{/* ----- */}
									{/* Botão "Administrativo" - leva ao manager */}
									{/* ----- */}
									{showManagerButton && (
										<Nav
											className="flex-column p-1 mt-auto"
											onClick={() => {
												if (user.is_superuser) {
													history.push(
														"/manager/admin/dashboard"
													);
												} else {
													history.push(
														"/manager/partner/dashboard"
													);
												}
											}}
										>
											<Nav.Item className="d-flex align-items-center hoverMenu">
												<span className="d-flex mx-3 menu-icon">
													<MdOutlineAdminPanelSettings />
												</span>{" "}
												{translation(
													"components.menu.administrative"
												)}
											</Nav.Item>
										</Nav>
									)}
									{/* ----- *** ----- */}
									{/* Botão de documentação - direciona o usuário para a página de documentação da API */}
									{/* ----- *** ----- */}
									<Nav
										className={`flex-column p-1 ${
											showManagerButton ? "" : "mt-auto"
										}`}
										onClick={handleRedirectToDocs}
									>
										<Nav.Item className="d-flex align-items-center hoverMenu">
											<span className="d-flex mx-3 menu-icon">
												<MdOutlineApi />
											</span>{" "}
											{translation(
												"components.menu.documentation"
											)}
										</Nav.Item>
									</Nav>
									{/* ----- *** ----- */}
									{/* Botão de Logout */}
									{/* ----- *** ----- */}
									<Nav
										className="flex-column p-1 mb-2"
										onClick={() => handleLogout()}
									>
										<Nav.Item className="d-flex align-items-center hoverMenu">
											<span className="d-flex mx-3 menu-icon">
												<MdOutlineLogout />
											</span>{" "}
											{translation(
												"components.menu.logout"
											)}
										</Nav.Item>
									</Nav>
								</>
							) : (
								<>
									<Nav
										className="flex-column p-1"
										onClick={() =>
											window.open(
												"https://dstoreconteudos.com.br/#planos"
											)
										}
									>
										<Nav.Item
											className="d-flex align-items-center hoverMenu"
											style={{ color: "#6473FF" }}
										>
											<span
												className="d-flex mx-3 menu-icon"
												style={{ color: "#6473FF" }}
											>
												<MdStar />
											</span>{" "}
											{translation(
												"components.menu.buyPlans"
											)}
										</Nav.Item>
									</Nav>
									<Nav
										className="flex-column p-1"
										onClick={() =>
											history.push("/create-account")
										}
									>
										<Nav.Item className="d-flex align-items-center hoverMenu">
											<span className="d-flex mx-3 menu-icon">
												<MdPersonAdd />
											</span>{" "}
											{translation(
												"components.menu.register"
											)}
										</Nav.Item>
									</Nav>
									<Nav
										className="flex-column p-1"
										onClick={() => history.push("/login")}
									>
										<Nav.Item className="d-flex align-items-center hoverMenu">
											<span className="d-flex mx-3 menu-icon">
												<MdLogin />
											</span>{" "}
											{translation(
												"components.menu.login"
											)}
										</Nav.Item>
									</Nav>
								</>
							)}
						</>
					)}
				</UserInfo>

				{/* Submenu das políticas de privacidade */}
				<PrivacyPolicies
					show={show}
					showUserInfo={showPrivacy}
				>
					<Nav
						className="flex-column p-2"
						onClick={() => {
							setShowPrivacy(false);
						}}
					>
						<Nav.Item className="d-flex align-items-center hoverMenu p-2">
							<span className="d-flex mr-3 menu-icon">
								<MdOutlineArrowBack />
							</span>
							{translation("components.menu.back")}
						</Nav.Item>
					</Nav>

					{availableDocs.includes("privacy") && (
						<Nav
							className="flex-column p-2"
							onClick={() => {
								history.push("/privacy");
								handleCloseMenus();
							}}
						>
							<Nav.Item className="d-flex align-items-center hoverMenu p-2 gap-0">
								<span className="d-flex mr-3 menu-icon">
									<MdOutlinePolicy />
								</span>
								{translation("privacy.privacy_policy")}
							</Nav.Item>
						</Nav>
					)}

					{availableDocs.includes("tos") && (
						<Nav
							className="flex-column p-2"
							onClick={() => {
								history.push("/tos");
								handleCloseMenus();
							}}
						>
							<Nav.Item className="d-flex align-items-center hoverMenu p-2">
								<span className="d-flex mr-3 menu-icon">
									<MdOutlinePrivacyTip />
								</span>
								{translation("privacy.tos")}
							</Nav.Item>
						</Nav>
					)}
				</PrivacyPolicies>

				{/* Submenu que contém as notificações */}
				<Notifications
					show={show}
					showUserInfo={showNotifications}
					className={"d-flex flex-column"}
				>
					{/* Componentes que gerencia as notificações */}
					<NotificationsPanel />
				</Notifications>

				{/* Outlet -- parte direita da página, que muda conforme o path */}
				<ContentPage
					show={show}
					showUserInfo={showUserInfo}
				>
					<Content>
						<Route
							path="/home"
							component={Home}
						/>
						<Route
							path="/courses"
							component={CoursesList}
							exact
						/>
						<Route
							path="/courses/:id"
							component={CourseDetails}
						/>
						<Route
							path="/disciplines"
							component={DisciplineList}
							exact
						/>
						<Route
							path="/disciplines/:id"
							component={DisciplineDetails}
						/>
						<Route
							path="/unity"
							component={UnitiesList}
							exact
						/>
						<Route
							path="/unity/:id"
							component={UnityDetails}
						/>
						<Route
							path="/objects"
							component={MediaList}
							exact
						/>
						<Route
							path="/objects/:id"
							component={MediaDetails}
							exact
						/>
						<Route
							path="/materials"
							component={Materials}
							exact
						/>
						<Route
							path="/favorites"
							component={Favorites}
							exact
						/>
						<Route
							path="/user-account"
							component={UserAccount}
							exact
						/>
						<Route
							path="/contact"
							component={SupportContact}
							exact
						/>
						<Route
							path="/privacy"
							component={Privacy}
							exact
						/>
						<Route
							path="/tos"
							component={ToS}
							exact
						/>
					</Content>
				</ContentPage>
			</Wrraper>
			<ButtonContact signature={true} />
		</Fragment>
	);
};

export default {
	routeProps: {
		path: "/",
		component: Base,
	},
	children: [
		"/home",
		"/unity",
		"/disciplines",
		"/courses",
		"/objects",
		"/favorites",
		"/materials",
		"/user-account",
		"/contact",
		"/courses/:id",
		"/disciplines/:id",
		"/unity/:id",
		"/objects/:id",
	],
	name: "Base",
};
